export async function copyTextToClipboard(text, { alertOnFailure = true } = {}) {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    console.warn('copyTextToClipboard called outside of a browser context.')
    return false
  }

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
    } else {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      const successful = document.execCommand('copy')
      document.body.removeChild(textArea)

      if (!successful) {
        throw new Error('document.execCommand("copy") returned false')
      }
    }

    return true
  } catch (error) {
    console.error('Failed to copy text to clipboard:', error)

    if (alertOnFailure) {
      alert(`Failed to copy automatically. Please copy this text manually:\n\n${text}`)
    }

    return false
  }
}

export default copyTextToClipboard
